export const PACKAGE_NAME = 'collect_actions';
